import React from "react";

import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

import {
  formatDateTime,
  getTimezoneDate,
  timezones,
} from "../../utilities/helpers";

import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

import QRCode from "qrcode";

import "./actionBtns.scss";

export default function ActionBtns({
  handleClick,
  ticketStatus,
  order,
  eventObj,
}) {
  const event = order?.event || eventObj;
  const timezone = timezones(event?.venue?.timezone);

  let hideSell =
    order?.tickets?.filter((ticket) => ticket.free === true).length > 0 ||
    !order ||
    !event?.enableResale;

  const handlePrintPDF = async (event, tickets) => {
    if (tickets.length === 0 || !event) {
      console.warn("No Tickets or events selected");
      return;
    }

    const pdfDoc = await PDFDocument.create();
    const embeddedFonts = {
      helveticaBold: await pdfDoc.embedFont(StandardFonts.HelveticaBold),
    };
    const embeddedImages = {};

    // Map for easy access
    const eventsMap = {};
    eventsMap[event.uuid] = event;
    console.log(tickets, eventsMap);

    for (const ticket of tickets) {
      const qrDataUrl = await QRCode.toDataURL(ticket.checkInCode);
      if (!qrDataUrl) {
        console.warn("Could not make qrcode...");
        setIsSaving(false);
        return;
      }

      const event = eventsMap[ticket.eventId];
      if (!event) {
        console.warn("Could not find matching event...");
        return;
      }

      if (!embeddedImages[qrDataUrl]) {
        embeddedImages[qrDataUrl] = await pdfDoc.embedPng(qrDataUrl);
      }
      addTicketPage(
        pdfDoc,
        ticket,
        event,
        embeddedFonts,
        embeddedImages[qrDataUrl],
      );
    }

    // Download the single PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${event?.name}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const addTicketPage = (pdfDoc, ticket, event, fonts, qrImage) => {
    const page = pdfDoc.addPage([400, 200]);
    const { width, height } = page.getSize();
    const { helveticaBold } = fonts;

    // Event details
    const eventName = event.name;
    let eventDate = getTimezoneDate(event.start, timezone);
    eventDate = formatDateTime(eventDate);
    const venue = event?.venue?.name;
    let location;
    if (ticket.generalAdmission) {
      location = `General Admission: ${ticket?.sectionNumber}`;
    } else {
      location = `Section ${ticket?.sectionNumber}, Row ${ticket?.rowNumber}, Seat ${ticket?.seatNumber}`;
    }

    // Add text
    page.drawText(eventName, {
      x: 20,
      y: height - 30,
      size: 12,
      font: helveticaBold,
      color: rgb(0, 0, 0),
    });

    page.drawText(`Date: ${eventDate}`, {
      x: 20,
      y: height - 50,
      size: 12,
      font: helveticaBold,
    });

    page.drawText(`Venue: ${venue}`, {
      x: 20,
      y: height - 70,
      size: 12,
      font: helveticaBold,
    });

    page.drawText(`Location: ${location}`, {
      x: 20,
      y: height - 90,
      size: 12,
      font: helveticaBold,
    });

    // Draw QR code
    if (qrImage) {
      page.drawImage(qrImage, {
        x: 300,
        y: height - 130,
        width: 80,
        height: 80,
      });
    } else {
      page.drawText("QR Code Missing", {
        x: 300,
        y: height - 100,
        size: 10,
        font: helveticaBold,
      });
    }
  };

  return (
    <Stack
      direction="horizontal"
      gap={3}
      className="btn-group-flex justify-content-center action-btns justify-content-md-end mt-md-2"
    >
      <Button
        onClick={() => handlePrintPDF(event, order?.tickets)}
        className="icon-button-sm icon-button--black btn-print"
        variant="info"
        disabled={order?.tickets?.length === 0}
        size="lg"
      >
        Print all
      </Button>
      {event?.enableTransfers && (
        <Button
          onClick={() => handleClick("transfer")}
          variant="dark"
          size="lg"
          disabled={
            ticketStatus === "transferred" && order?.tickets?.length === 0
          }
        >
          Transfer
        </Button>
      )}
      {!hideSell && (
        <Button
          disabled={ticketStatus === "listed" && order?.tickets?.length === 0}
          onClick={() => handleClick("sell")}
          variant="dark"
          size="lg"
        >
          Sell
        </Button>
      )}
    </Stack>
  );
}
